import * as types from './actionTypes';

const initialState = {
  tax: null,
  loading: false,
  error: null,
  success: false,
};

const taxReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PAYROLL_DEDUCTION_FETCH_TAX:
    case types.PAYROLL_DEDUCTION_SAVE_TAX:
    case types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.PAYROLL_DEDUCTION_FETCH_TAX_SUCCESS:
      return {
        ...state,
        tax: action.payload?.data,
        loading: false,
        success: false,
      };

    case types.PAYROLL_DEDUCTION_SAVE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.PAYROLL_DEDUCTION_FETCH_TAX_FAILURE:
    case types.PAYROLL_DEDUCTION_SAVE_TAX_FAILURE:
    case types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default taxReducer;
